// extracted by mini-css-extract-plugin
export default {"box":"pricing-list_box__mXVqh","divider":"pricing-list_divider__sLHMI","record":"pricing-list_record__Ee5f5","label":"pricing-list_label__C0geJ","value":"pricing-list_value__-GQgm"};